module.exports = __webpack_public_path__ + "static/media/icon-oportunidades-pessoas-fisicas.white.2301c2bf.svg";